import './TenantLogo.scss';
import { Typography } from '@mui/material';
import { ITenantData } from '../common/types';
import ClockSVG from '../resources/images/clock.svg';

const TenantLogo = (tenant: ITenantData, onSelect: Function, isSelected: boolean, colorMap: any) => {
    const newColor = (tenantId: string) => {
        const generateColor = () => {
            let randomColorString = '#';
            const arrayOfColorFunctions = '0123456789abcdef';
            for (let x = 0; x < 6; x++) {
                const index = Math.floor(Math.random() * 16);
                const value = arrayOfColorFunctions[index];

                randomColorString += value;
            }
            return randomColorString;
        };

        // If already generated and assigned, return
        if (colorMap[tenantId]) {
            return colorMap[tenantId];
        }

        // Generate new random color
        const colorSet = new Set(Object.values(colorMap));
        let newColor;

        do {
            newColor = generateColor();
        } while (colorSet.has(newColor));

        // Found a new random, unassigned color
        colorMap[tenantId] = newColor;

        // Return next new color
        return newColor;
    };

    const getDateString = (date: Date) => {
        const calcDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        const calcTime = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return `${calcDate} - ${calcTime}`;
    };

    return (
        <div className="TenantLogo" key={tenant.rowid}>
            <div onClick={() => onSelect()} data-testid={`tenant-hexagon-${tenant.rowid}`} className="TenantHexagon">
                <div className={isSelected ? 'CompanyBackgroundSelected' : 'CompanyBackground'} />
                {tenant.logo_url ? (
                    <img className="CompanyLogo" src={tenant.logo_url} alt={`${tenant.tenant_name}logo`} />
                ) : (
                    <Typography className="CompanyLogoLetter" color={newColor(tenant.rowid)}>
                        {tenant.tenant_name[0]}
                    </Typography>
                )}
            </div>
            <Typography align="center" className="TenantName">
                {tenant.tenant_name}
            </Typography>
            {tenant.last_updated_project ? (
                <div className="Timestamp">
                    <img src={ClockSVG} alt="clock" />
                    <Typography align="center" className="TimestampText">
                        {getDateString(new Date(tenant.last_updated_project))}
                    </Typography>
                </div>
            ) : null}
        </div>
    );
};

export default TenantLogo;
